import { useEffect, useState } from 'react'
import {
  getOrganizationInvoices,
  type GetOrganizationInvoicesParams,
  type OrganizationInvoicesPageDto,
} from '@/lib/api/v2/invoices'

export function useOrganizationInvoices(params: GetOrganizationInvoicesParams) {
  const [data, setData] = useState<OrganizationInvoicesPageDto | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [reloadKey, setReloadKey] = useState(0)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)
    setError(null)

    getOrganizationInvoices(params)
      .then((d) => {
        if (cancelled) return
        setData(d)
      })
      .catch((e) => {
        if (cancelled) return
        setError(e)
        setData(null)
      })
      .finally(() => {
        if (cancelled) return
        setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    params.page,
    params.pageSize,
    params.type,
    params.from,
    params.to,
    params.q,
    params.orderBy,
    params.orderDir,
    reloadKey,
  ])

  const refetch = () => setReloadKey((k) => k + 1)

  return { data, isLoading, error, refetch }
}
